
import { OrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { BuyDownloadButtonCSV, BuyDownloadButtonPDF, BuyDownloadPdfTemplateButton, BuyDownloadTags, BuyPdfPreview, BuySupplierPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/BuyButtons'
import locations from '../../../../../../../../../../utils/globals/locations'
import { BuyDeliveryNoteDuplicateButton } from '../../../BuyDeliveryNoteButtons'
import { useCallback, useMemo } from 'react'
import { ButtonDisabledOrLoader } from '../../../../../../../../../../baseComponents/Button'
import { getUserPermissions } from '../../../../../../../../../../utils/reducers/getters'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { ButtonOrderInfoLeftBase, OrderDivideIntoChaptersButton, OrderProductTypesButton, OrderVariablesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { changeErrorMessage } from '../../../../../../../../../../utils/reducers/reduxDispatch'
import { useNavigate } from 'react-router'
import twinFetchPost from '../../../../../../../../../../utils/globals/data'
import { parseSelectedTableForProcessing } from '../../../../../functions'
import { BuyDeliveryNoteStatusInversed } from '@teinor/erp/types/company/order/buy/buyDeliveryNote'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'

const BuyDeliveryNoteWaitingResponseStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    const OrderId = data?.header?.id
    return (
        <div className='flex items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useBuyDeliveryNoteWaitingResponseStepButtonsLogic, ...rest }} className='mr-8' />
            <BuyDeliveryNoteProcessInvoiceButton title={t('invoiceDeliveryNote', 'Facturar albarán')} data={data} {...{ OrderId, orderStatus: BuyDeliveryNoteStatusInversed['accepted'] }} />
        </div>
    )
}

const useBuyDeliveryNoteWaitingResponseStepButtonsLogic = ({ data, onSubmit, isReadOnly, userPermissions, orderHeaderURLs, setCompleteData, updateHeaderData }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const Order = data?.header
    const name = 'buy_delivery_note_waiting_response_step_buttons'

    const defaultButtons = [{ "id": "previewBuyDeliveryNotePDF" }, { "id": "downloadBuyDeliveryNote" }, { "id": "duplicateBuyDeliveryNote" }]

    const buyDeliveryNoteDuplicateText = t('duplicateBuyDeliveryNote', 'Duplicar albarán de compra')
    const buyDeliveryNoteDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const buyDeliveryNoteDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const buyDeliveryNotePreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const buyDeliveryNoteDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const buyDeliveryNoteDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const buyDeliveryNoteDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const buyDeliveryNoteVariablesText = t('variables', 'Variables')
    const buyOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')
    const buyOrderPreviewSupplierPDFText = t('previewSupplierPDF', 'Previsualizar PDF proveedor')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            duplicateBuyDeliveryNote: {
                component: BuyDeliveryNoteDuplicateButton,
                extraProps: {
                    title: buyDeliveryNoteDuplicateText,
                    id: 'duplicateBuyDeliveryNote',
                    allRowData: data,
                    permissionTy: 'buy.deliveryNote',
                }
            },
            downloadBuyCsv: {
                component: BuyDownloadButtonCSV,
                extraProps: {
                    title: buyDeliveryNoteDownloadCSVText,
                    id: 'downloadBuyCsv',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyTag: {
                component: BuyDownloadTags,
                extraProps: {
                    title: buyDeliveryNoteDownloadTagsText,
                    id: 'downloadBuyTag',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            previewBuySupplierPDF: {
                component: BuySupplierPdfPreview,
                showButton: Order.supplierPdf?.length,
                extraProps: {
                    title: buyOrderPreviewSupplierPDFText,
                    id: 'previewBuyOrderPDFSupplier',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDFSupplier'
                }
            },
            previewBuyDeliveryNotePDF: {
                component: BuyPdfPreview,
                extraProps: {
                    title: buyDeliveryNotePreviewPDFText,
                    id: 'previewBuyDeliveryNotePDF',
                    key: 'previewBuyDeliveryNotePDF',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyDeliveryNoteTemplate: {
                component: BuyDownloadPdfTemplateButton,
                extraProps: {
                    title: buyDeliveryNoteDownloadPDFTemplateText,
                    id: 'downloadBuyDeliveryNoteTemplate',
                    key: 'downloadBuyDeliveryNoteTemplate',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyDeliveryNote: {
                component: BuyDownloadButtonPDF,
                extraProps: {
                    title: buyDeliveryNoteDownloadPDFText,
                    id: 'downloadBuyDeliveryNote',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: buyDeliveryNoteDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
            variablesQuote: {
                component: OrderVariablesButton,
                extraProps: {
                    title: buyDeliveryNoteVariablesText,
                    id: 'variablesQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
            buyProductTypes: {
                component: OrderProductTypesButton,
                extraProps: {
                    title: buyOrderProductTypesText,
                    id: 'buyProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, data, onSubmit, buyDeliveryNoteDivideIntoChaptersText, buyDeliveryNoteDownloadCSVText, buyDeliveryNoteDownloadPDFTemplateText, buyDeliveryNoteDownloadPDFText, buyDeliveryNoteDownloadTagsText, buyDeliveryNoteDuplicateText, buyDeliveryNotePreviewPDFText, buyDeliveryNoteVariablesText, isReadOnly, buyOrderProductTypesText, buyOrderPreviewSupplierPDFText])

    return { name, ButtonComponents, defaultButtons }
}

export const BuyDeliveryNoteWaitingResponseStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    const OrderId = data?.header?.id
    return (
        <div className='flex order_config_buttons_parent items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useBuyDeliveryNoteWaitingResponseStepButtonsLogic, ...rest }} className='mr-8' />
            <BuyDeliveryNoteProcessInvoiceButton title={t('invoiceDeliveryNote', 'Facturar albarán')} data={data} {...{ OrderId, orderStatus: BuyDeliveryNoteStatusInversed['accepted'] }} />
        </div>
    )
}

interface BuyDeliveryNoteProcessInvoiceButtonProps extends BuyDeliveryNoteProcessInvoiceButtonLogicProps {
    title: string
}
const BuyDeliveryNoteProcessInvoiceButton: React.FC<BuyDeliveryNoteProcessInvoiceButtonProps> = ({ data, title }) => {
    const { t } = useTwinTranslation()
    const { finalizeOrder, selectedProducts, loading } = useBuyDeliveryNoteProcessInvoiceButtonLogic({ data })
    const invoicePermision = permissionCheck(getUserPermissions('buy.invoice'), 'create')
    const canProcess = selectedProducts.processing.units > 0
    let infoMessage = null
    if (!invoicePermision) {
        infoMessage = t('NotPermissionForCreate', 'No tienes permisos de creación')
    } else if (!canProcess) {
        infoMessage = t('mustAddQuantityToSelectedProducts', 'Debes añadir a los productos seleccionados una cantidad superior a 0')
    }
    return (
        <ButtonOrderInfoLeftBase disabled={infoMessage ? true : false} infoMessage={infoMessage || ''}>
            <div className='min-w-175'>
                <ButtonDisabledOrLoader onClick={finalizeOrder} buttonIsDisabled={infoMessage ? true : false} textButton={title} loading={loading} className='w-full' />
            </div>
        </ButtonOrderInfoLeftBase>
    )
}

interface BuyDeliveryNoteProcessInvoiceButtonLogicProps {
    data: OrderData
}

const useBuyDeliveryNoteProcessInvoiceButtonLogic = ({ data }: BuyDeliveryNoteProcessInvoiceButtonLogicProps) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const noProductsMsg = t('notProcessedAnyProducts', 'No has procesado ningún producto')
    const selectedProducts = useMemo(() => parseSelectedTableForProcessing(data), [data])
    const { startLoading, endLoading, loading } = useIsLoading()

    const finalizeOrder = useCallback(async () => {
        startLoading?.()
        const response = await twinFetchPost('/api/app/order/buy/buyDeliveryNote/createBuyInvoiceFromBuyDeliveryNote', { selectedProducts: selectedProducts.forSend.products, OrderId: data?.header?.id})
        const responseJSON = await response.json()
        if (response.status === 200) {
            navigate(locations.buyInvoiceSingle + '/' + responseJSON.id)
        } else {
            if (responseJSON.errors[0].msg === 'noProducts') {
                changeErrorMessage(noProductsMsg)
            } else {
                changeErrorMessage(responseJSON.errors[0].msg)
            }
        }
        endLoading?.()
    }, [data, noProductsMsg, navigate, selectedProducts, startLoading, endLoading])

    return { finalizeOrder, selectedProducts, loading }
}

export default BuyDeliveryNoteWaitingResponseStepButtons